import React from 'react';
import { TextField, List, ListItem, Paper, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { motion } from 'framer-motion';

const InputAddressComponent = ({ address, addressSuggestions, handleAddressChange, handleSelectAddress }) => {
    return (
        <div>
            <TextField
                fullWidth
                variant="outlined"
                placeholder="Enter address"
                value={address}
                onChange={handleAddressChange}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon style={{ color: '#757575' }} />
                        </InputAdornment>
                    ),
                    sx: {
                        borderRadius: '25px',
                        backgroundColor: '#fff',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                        '&:hover': {
                            boxShadow: '0 6px 10px rgba(0, 0, 0, 0.15)',
                        },
                    },
                }}
            />
            {addressSuggestions.length > 0 && (
                <motion.div
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -10 }}
                    transition={{ duration: 0.2 }}
                >
                    <Paper>
                        <List>
                            {addressSuggestions.map((suggestion, index) => (
                                <ListItem 
                                    key={index} 
                                    button 
                                    onClick={() => handleSelectAddress(suggestion)}
                                >
                                    {suggestion}
                                </ListItem>
                            ))}
                        </List>
                    </Paper>
                </motion.div>
            )}
        </div>
    );
};

export default InputAddressComponent;
